import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import { t } from "i18next";

const SelectVolumesModels = ({ value, onChange }) => {
  const handleChange = (event) => {
    onChange?.(event.target.value);
  };

  return (
    <FormControl sx={{ width: "fit-content", minWidth: "150px" }}>
      <InputLabel id="select-volumes-label">
        {t("real-time-page.variables-selector-label")}
      </InputLabel>
      <Select
        labelId="select-volumes-label"
        id="select-volumes"
        value={value}
        label={t("real-time-page.variables-selector-label")}
        onChange={handleChange}
      >
        <MenuItem value={"inflow"}>
          {t("real-time-page.data_from_model_chart.total_in_flow")}
        </MenuItem>
        <MenuItem value={"outflow"}>
          {t("real-time-page.data_from_model_chart.total_out_flow")}
        </MenuItem>
        <MenuItem value={"storage"}>
          {t("real-time-page.data_from_model_chart.volumes")}
        </MenuItem>
      </Select>
    </FormControl>
  );
};

export default SelectVolumesModels;
